import { Link } from "react-router-dom"
import { getCookie, setCookie } from "../../helpers/cookies"
import { UserContext } from "../../store/store"
import { useState, useContext, useEffect } from "react"
import { Switch } from "./Switch"
import { useTranslation } from "react-i18next"
import { langs } from "../../services/statics"

const Footer = () => {
  const [state, dispatch] = useContext(UserContext)

  // switch theme
  const [status, setStatus] = useState(false)

  useEffect(() => {
    const res = state.theme === "light"
    setStatus(res)
  }, [state, setStatus])

  const handleClick = () => {
    const newVal = state.theme === "dark" ? "light" : "dark"
    dispatch({
      type: "SET_THEME",
      payload: {
        theme: newVal,
      },
    })
    setCookie("theme", newVal, 30)
  }

  const { t, i18n } = useTranslation()

  const setLang = (code) => {
    i18n.changeLanguage(code)
    setCookie("i18n", code, 30)
  }

  const c = getCookie("i18n")

  return (
    <div id="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-12">
            <div style={{ display: "flex", alignItems: "center" }}>
              <select
                className="form-select form-select-sm me-3"
                style={{ width: "min-content" }}
                defaultValue={c ? c : i18n.resolvedLanguage}
                onChange={(e) => setLang(e.target.value)}>
                {langs.map((code) => (
                  <option key={code} value={code}>
                    {t(`index.footer.langs.${code}.emoji`)}{" "}
                    {t(`index.footer.langs.${code}.name`)}
                  </option>
                ))}
              </select>

              <span className="theme-switch">
                <Switch
                  status={status}
                  setStatus={setStatus}
                  onClick={handleClick}
                />
              </span>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <ul style={{ float: "right" }}>
              <li>
                <Link to="/sugerencias">{t("index.footer.suggestions")}</Link>
                &nbsp;&nbsp;·
              </li>
              <li>
                <Link to="/acerca">{t("index.footer.about")}</Link>&nbsp;&nbsp;·
              </li>
              <li>
                <a href="mailto:pln@fing.edu.uy">{t("index.footer.contact")}</a>
              </li>
              <li>
                <span className="copy">&copy; {new Date().getFullYear()}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
